import script from "./Seatplan.vue?vue&type=script&setup=true&lang=js"
export * from "./Seatplan.vue?vue&type=script&setup=true&lang=js"

import "./Seatplan.vue?vue&type=style&index=0&id=04e55daa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04e55daa"]])

export default __exports__